import { Html } from "@react-three/drei";

const Exo = (props) => {
  return (
    <>
      <Html className="page" {...props} fullscreen zIndexRange={[0, 0]}>
        {props.visible ? (
          <>
            <h1 className="title">EXOSKELETON</h1>
            <p className="text">
              Cybertruck is built with an exterior shell made for ultimate
              durability and passenger protection. Starting with a nearly
              impenetrable exoskeleton, every component is designed for superior
              strength and endurance, from Ultra-Hard 30X Cold-Rolled
              stainless-steel structural skin to Tesla armor glass.
            </p>
          </>
        ) : null}
      </Html>
    </>
  );
};

export default Exo;
